"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var inversify_1 = require("inversify");
var Symbol = require("es6-symbol");
var _1 = require("./");
var TYPES = {
    Utility: Symbol("Utility"),
    DateFormatter: Symbol("DateFormatter"),
    ModelMapper: Symbol("ModelMapper"),
    IHALParser: Symbol("IHALParser"),
    IURLFactory: Symbol("IURLFactory")
};
exports.TYPES = TYPES;
var diModule = new inversify_1.ContainerModule(function (bind) {
    bind(TYPES.Utility).to(_1.Utility);
    bind(TYPES.DateFormatter).to(_1.DateFormatter);
    bind(TYPES.ModelMapper).to(_1.ModelMapper);
    bind(TYPES.IHALParser).toConstantValue(_1.HALParser);
});
exports.diModule = diModule;
